import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";

import api from "@/services/api.service";

import classes from "./layout.module.scss";
import { CLEAR_SURVEY } from "@/redux/types/auth.types";
import { isMobile } from "@/services/Utils";

const Survey = () => {
	const dispatch = useDispatch();
	const { addToast } = useToasts();

	const [score, setScore] = useState("");
	const [localSurvey, setLocalSurvey] = useState({});

	const { user, survey } = useSelector((state) => state.auth);

	useEffect(() => {
		if (survey) {
			setLocalSurvey(JSON.parse(JSON.stringify(survey)));
		}
	}, [survey]);

	if (!survey) {
		return null;
	}

	const handleAnswer = (no_answer = false) => {
		if (!score) {
			addToast("Por favor selecciona una calificación", { appearance: "error" });
			return;
		}

		dispatch({
			type: CLEAR_SURVEY,
		});

		api.post("/admin/surveys/answer", { ...localSurvey, score, no_answer: no_answer })
			.then(() => {
				addToast("Gracias por tu respuesta!", { appearance: "success" });
			})
			.catch((error) => {
				console.error(error);
			});
	};

	if (isMobile()) {
		return null;
	}

	return (
		<div className={classes.mainSurvey}>
			<div className={classes.formSurvey}>
				<div className={classes.titlesSurvey}>
					<div className={classes.first}>
						{user && user.full_name ? user.full_name.split(" ")[0].charAt(0).toUpperCase() + user.full_name.split(" ")[0].slice(1) : ""}, ayudanos a
						mejorar.
					</div>
					<div className={classes.second}>{localSurvey.title}</div>
					<div className={classes.second}>{localSurvey.description}</div>
				</div>

				<div className={classes.numbersSurvey}>
					<div
						className={`${classes.numberSurvey} ${Number(score) === 1 && classes.selected} `}
						onClick={() => setScore(1)}
						style={{ backgroundColor: "#ff0000" }}
					>
						1
					</div>
					<div
						className={`${classes.numberSurvey} ${Number(score) === 2 && classes.selected} `}
						onClick={() => setScore(2)}
						style={{ backgroundColor: "#e32f00" }}
					>
						2
					</div>
					<div
						className={`${classes.numberSurvey} ${Number(score) === 3 && classes.selected} `}
						onClick={() => setScore(3)}
						style={{ backgroundColor: "#c75f00" }}
					>
						3
					</div>
					<div
						className={`${classes.numberSurvey} ${Number(score) === 4 && classes.selected} `}
						onClick={() => setScore(4)}
						style={{ backgroundColor: "#ab8f00" }}
					>
						4
					</div>
					<div
						className={`${classes.numberSurvey} ${Number(score) === 5 && classes.selected} `}
						onClick={() => setScore(5)}
						style={{ backgroundColor: "#8fbf00" }}
					>
						5
					</div>
					<div
						className={`${classes.numberSurvey} ${Number(score) === 6 && classes.selected} `}
						onClick={() => setScore(6)}
						style={{ backgroundColor: "#6dbf00" }}
					>
						6
					</div>
					<div
						className={`${classes.numberSurvey} ${Number(score) === 7 && classes.selected} `}
						onClick={() => setScore(7)}
						style={{ backgroundColor: "#52bf00" }}
					>
						7
					</div>
					<div
						className={`${classes.numberSurvey} ${Number(score) === 8 && classes.selected} `}
						onClick={() => setScore(8)}
						style={{ backgroundColor: "#41d300" }}
					>
						8
					</div>
					<div
						className={`${classes.numberSurvey} ${Number(score) === 9 && classes.selected} `}
						onClick={() => setScore(9)}
						style={{ backgroundColor: "#2ba600" }}
					>
						9
					</div>
					<div
						className={`${classes.numberSurvey} ${Number(score) === 10 && classes.selected} `}
						onClick={() => setScore(10)}
						style={{ backgroundColor: "#008000" }}
					>
						10
					</div>
				</div>

				{survey && localSurvey.items && localSurvey.items.length > 0 && score && (
					<div className={classes.questionsSurvey}>
						{localSurvey.items.map((item, index) => (
							<React.Fragment key={index}>
								<div className={classes.questionSurvey}>
									<div className={classes.question}>
										{item.description}{" "}
										<small>
											<i> (Opcional)</i>
										</small>
									</div>
								</div>
								<textarea
									className={classes.textareaAnswer}
									placeholder=""
									onChange={(e) => {
										const newSurvey = { ...localSurvey };
										newSurvey.items[index].answer = e.target.value;
										setLocalSurvey(newSurvey);
									}}
								/>
							</React.Fragment>
						))}
					</div>
				)}

				<div className={classes.buttonsSurvey}>
					{/* <div className={`${classes.buttonSurvey} ${classes.no_answer}`} onClick={() => handleAnswer(true)}>
						No responder
					</div> */}
					<div className={classes.buttonSurvey} onClick={() => handleAnswer()}>
						Enviar Respuesta
					</div>
				</div>
			</div>
		</div>
	);
};

export default Survey;
